export default __webpack_public_path__ + "static/media/minusquantity.a9fb7412.svg";